import { render } from "./activityScale.vue?vue&type=template&id=377fbb4b&scoped=true"
import script from "./activityScale.vue?vue&type=script&lang=js"
export * from "./activityScale.vue?vue&type=script&lang=js"

import "./activityScale.vue?vue&type=style&index=0&id=377fbb4b&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-377fbb4b"]])

export default __exports__